import { Box } from '@mui/material'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Panel from 'components/Panel'
import Modal from 'components/Modal'
import Form from 'components/Form'
import { useSnackbar } from 'notistack'
import { setInfo, clearInfo } from 'slices/infoSlice'
import { normalizeData } from 'utilities/validator'
import usePopup from 'hooks/usePopup'
import useAxios from 'hooks/useAxios'
import { warpUpFailResponse } from 'utilities/utils'
import useDataHandler from 'hooks/useDataHandler'

export default function VehicleType() {
	const dispatch = useDispatch()
	const { enqueueSnackbar } = useSnackbar();
	const { post, del, multiple, get } = useAxios();
	const { save } = useDataHandler()
	const info = useSelector(state => state.info.ctx || {})
	const [mode, setMode] = useState("initial")
	const { confirmPopup } = usePopup();
	const [allVehicleType, setAllVehicleType] = useState([]);
	const roleUser = useSelector(state => state.user.roleName)
	const fetchData = async controller => {
		const result = await multiple([
			{ method: "get", url: "/vehicleType/getAllVehicleType", config: { signal: controller.signal } }
		])
		if (result[0].status === 200) {
			const vehicleTypes = result[0].data.data || []
			setAllVehicleType(vehicleTypes)
		}
	}

	useEffect(() => {
		const controller = new AbortController();
		fetchData(controller)
		return () => {
			controller.abort()
		}
	}, [])

	const onCloseModal = useCallback(() => {
		confirmPopup({
			title: "แจ้งเตือน",
			content: "ท่านต้องการยกเลิกการแก้ไขหรือไม่",
			onSubmit: () => {
				setMode("initial")
			}
		})
	}, [])

	const inputForm = [
		{
			rowData: [
				{
					type: "text",
					required: true,
					props: {
						id: "name",
						label: "ชื่อ",
						variant: "outlined"
					}
				}, {
					type: "text",
					props: {
						id: "fullName",
						label: "ชื่อเต็ม",
						variant: "outlined"
					}
				}
			]
		}, {
			rowData: [
				{
					type: "number",
					required: true,
					props: {
						id: "wheels",
						label: "จำนวนล้อ",
						variant: "outlined",
						max: 30
					}
				},
				mode === "edit" && {
					type: "dropdown",
					props: {
						id: "active",
						label: "สถานะ",
						options: [
							{ label: "ใช้งาน", value: true },
							{ label: "ไม่ใช้งาน", value: false }
						],
					}
				}
			]
		}, {
			rowData: [
				{
					type: "button",
					props: {
						label: "บันทึก",
						onClick: () => {
							saveData()
						},
						className: "!bg-bpTheme-buttonSubmit"
					}
				}
			]
		}
	]
	const table = useMemo(() => [
		{
			rowData: [{
				type: "dataTable",
				props: {
					columns: [
						{
							id: 'no',
							label: 'เลขที่ประเภทรถ',
							fields: ["no"]
						},
						{
							id: 'name',
							label: 'ชื่อ',
							fields: ["name"]
						},
						{
							id: 'fullName',
							label: 'ชื่อเต็ม',
							fields: ["fullName"]
						},
						{
							id: 'wheels',
							label: 'จำนวนล้อ',
							fields: ["wheels"]
						},
						{
							id: 'active',
							label: 'สถานะ',
							fields: ["active"],
							valuesMap: [{ label: "ใช้งาน", value: true }, { label: "ไม่ใช้งาน", value: false }]
						}
					],
					rows: allVehicleType,
					size: "small",
					showDeleteButton: roleUser === "Owner",
					title: "ข้อมูลประเภทรถ",
					showSystemFields: true,
					onClick: (e) => {
						setMode("edit")
						dispatch(setInfo(e))
					},
					onDelete: (e, onSuccess) => {
						confirmPopup({
							onSubmit: async () => {
								const result = await del("/vehicleType/deleteVehicleType", { ids: e.map(data => data.id).join(',') })
								if (result.status === 200) {
									enqueueSnackbar('ลบสำเร็จ', { variant: "success" })
									dispatch(clearInfo())
									await fetchData(new AbortController())
									onSuccess()
								} else {
									enqueueSnackbar('ลบไม่สำเร็จ', { variant: "error" })
								}
							}
						})
					},
					controller: (paging) => get("/vehicleType/getAllVehicleType", { paging }),
					searchFields: [
						{ label: "ชื่อ", value: "name" },
						{ label: "ชื่อเต็ม", value: "fullName" },
						{ label: "จำนวนล้อ", value: "wheels" },
						{ label: "สถานะ", value: "active" }
					]
				}
			}]
		}, {
			noCol: true,
			rowData: [
				{
					type: "button",
					props: {
						label: "เพิ่มใหม่",
						onClick: () => {
							setMode("create")
							dispatch(clearInfo())
						}
					}
				},
				// {
				// 	type: "upload",
				// 	props: {
				// 		id: "files",
				// 		type: "button",
				// 		className: "!ml-2",
				// 		variant: "outlined",
				// 		maxFiles: 5
				// 	}
				// }
			]
		}
	], [allVehicleType])

	const saveData = useCallback(() => {
		save({
			data: info,
			onSubmit: async () => {
				const data = normalizeData(info)
				let response
				if (mode === "create") {
					response = await post("/vehicleType/createVehicleType", { ...data, active: true })
				} else if (mode === "edit") {
					response = await post("/vehicleType/updateVehicleType", { ...data })
				}
				if (response.status === 200) {
					setMode("initial")
					enqueueSnackbar('บันทึกสำเร็จ', { variant: "success" })
					fetchData(new AbortController())
				} else {
					enqueueSnackbar(warpUpFailResponse(response, 'บันทึกไม่สำเร็จ'), { variant: "error" })
				}
			},
			onCancel: () => {
				enqueueSnackbar('ยกเลิกรายการ', { variant: "info" })
			}
		})
	}, [info, mode])

	return (
		<Box>
			<Panel data={table}></Panel>
			<Modal open={mode === "create" || mode === "edit"} onClose={onCloseModal} className="form-modal" contentClassName="min-w-full md:!min-w-[750px]">
				<Form title={"ประเภทรถ " + (info.no || "")} name="user-form" data={inputForm}></Form>
			</Modal>
		</Box>
	)
}
